import type { IEnglishIqItemV2 } from '@repo/sdk';

interface IEnglishIqV2ChoiceAnswerProps {
  choices: Extract<
    IEnglishIqItemV2,
    { type: 'choice' | 'audio_choice' | 'video_choice' }
  >['choices'];
  disabled: boolean;
  onSelect: (choiceId: string) => void;
}

export function EnglishIqV2ChoiceAnswer({
  choices,
  disabled,
  onSelect,
}: IEnglishIqV2ChoiceAnswerProps): React.JSX.Element {
  return (
    <div className="grid gap-3 sm:grid-cols-2" dir="ltr">
      {choices.map((choice, index) => (
        <button
          aria-keyshortcuts={String(index + 1)}
          className="group flex min-h-16 items-center gap-4 rounded-2xl border border-[#f7edda]/15 bg-[#f7edda]/[0.04] px-4 py-3 text-left text-[#fff8e9] transition hover:-translate-y-0.5 hover:border-[#ff7a1a]/70 hover:bg-[#ff7a1a]/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ff7a1a] disabled:opacity-50 motion-reduce:transform-none motion-reduce:transition-none sm:min-h-20 sm:px-5"
          disabled={disabled}
          key={choice.id}
          onClick={() => onSelect(choice.id)}
          type="button"
        >
          <span className="grid size-8 shrink-0 place-items-center rounded-full border border-[#f7edda]/20 font-mono text-xs text-[#ffb36b] group-hover:border-[#ff7a1a]">
            {index + 1}
          </span>
          <span className="text-base font-medium leading-snug sm:text-lg">{choice.text}</span>
        </button>
      ))}
    </div>
  );
}
